import * as React from "react";
import GenericDropDown from "src/core/ui/generic-dropdown";
import Calendar from "./calendar";
import Button from "./button";
import Icon from "./icon";

export interface FormInputProps {
    value?: any;
    label?: string;
    error?: boolean;
    name?: string;
    style?: "dark" | "light" | "verify" | "black";
    type?: any;
    placeholder?: string;
    onChange?: (value: any) => void;
    disabled?: boolean;
    errors?: string[];
    extraContent?: any;
    notifyError?: (name: string, message: string, valid: boolean) => void;
    extraValidation?: (value: string) => { valid: boolean; defaultMessage: string };
    extraActions?: React.ReactNode;
    position?: "left" | "top";
    noInput?: boolean;
    className?: string;
    min?: number;
    max?: number;
    customInput?: any;
}

export interface FormInputState {
    value: any;
    errors: string[];
    error: boolean;
    type: string;
}

export default class FormInput extends React.Component<FormInputProps, FormInputState> {
    constructor(props: FormInputProps) {
        super(props);

        this.state = {
            value: "",
            errors: [],
            error: false,
            type: this.props.type,
        };
    }

    public componentDidMount() {
        this.setState({
            type: this.props.type || "text",
            value: this.props.value || "",
            errors: this.props.errors || [],
            error: this.props.error || false,
        });
    }

    notifyCHange = (value) => {
        if (this.props.onChange) this.props.onChange(value);
    };

    handleChange = (e) => {
        if (this.props.extraValidation) {
            var result = this.props.extraValidation(e.target.value);

            if (!result.valid) {
                this.setState({ errors: [result.defaultMessage] });

                if (this.props.notifyError) this.props.notifyError(this.props.name || "", result.defaultMessage, true);
            } else {
                this.setState({ errors: [], error: false });
                this.notifyCHange(e.target.value);
                if (this.props.notifyError) this.props.notifyError(this.props.name || "", result.defaultMessage, false);
            }
        } else {
            this.setState({ errors: [], error: false });

            this.notifyCHange(e.target.value);
            if (this.props.notifyError) this.props.notifyError(this.props.name || "", "", false);
        }

        this.notifyCHange(e.target.value);
        this.setState({ value: e.target.value });
    };

    renderInputBaseOnType = () => {
        switch (this.props.type) {
            case "date":
                return null;

            default:
                return (
                    <input
                        min={this.props.min}
                        max={this.props.max}
                        onInput={this.handleChange}
                        name={this.props.name}
                        disabled={this.props.disabled}
                        type={this.state.type}
                        placeholder={this.props.placeholder}
                        value={this.state.value}
                    />
                );
        }
    };

    public componentWillReceiveProps(nextProps: FormInputProps) {
        if (nextProps.value != this.props.value) this.setState({ value: nextProps.value });
        if (nextProps.error != this.props.error || (nextProps.errors != this.props.errors && nextProps.errors)) {
            this.setState({ error: nextProps.error || false, errors: nextProps.errors || [] });
        }
        if (nextProps.type != this.props.type) {
            this.setState({ type: nextProps.type });
        }
    }

    public render() {
        const switchIcon = (
            <Icon
                faType={this.state.type == "text" ? "eye-slash" : "eye"}
                type="edit"
                style={{ cursor: "pointer" }}
                onClick={() => this.setState({ type: this.state.type == "text" ? "password" : "text" })}
            />
        );

        return (
            <div
                className={
                    "form-input " +
                    (this.props.style || "dark ") +
                    (" " + this.props.position || " left ") +
                    (this.props.disabled ? " disabled" : " ") +
                    (this.props.error ? " error" : " " + (this.props.className || ""))
                }
            >
                {(this.props.label || this.props.noInput) && (
                    <label className={` ${this.props.position || " left"}`}>{this.props.label}</label>
                )}
                <div className="input-container">
                    {!this.props.noInput && this.renderInputBaseOnType()}
                    {this.props.noInput && this.props.customInput}
                    <div className="input-actions">
                        {this.props.type == "password" && switchIcon}
                        {this.props.extraActions}
                    </div>
                    {this.state.errors &&
                        this.state.errors.map((item, index) => {
                            return (
                                <p key={"input-error" + index} className="input-error">
                                    {item}
                                </p>
                            );
                        })}

                    {this.props.extraContent && <div style={{ marginTop: "20px" }}>{this.props.extraContent}</div>}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/core/ui/input.tsx